import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class AuthenticationGuard  {
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    this.authService.updateSession();
    return this.authService.session.pipe(
      map(session => !!session),
      tap(authenticated => {
        if (!authenticated) {
          this.router.navigate(['/signIn']);
        }
      })
    );
  }
}
